import { render, staticRenderFns } from "./pointsDetails.vue?vue&type=template&id=20a9c05e&scoped=true"
import script from "./pointsDetails.vue?vue&type=script&lang=js"
export * from "./pointsDetails.vue?vue&type=script&lang=js"
import style0 from "./pointsDetails.vue?vue&type=style&index=0&id=20a9c05e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a9c05e",
  null
  
)

export default component.exports